import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';

const Password = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get data from navigation state (no page refresh)
  const { email, name, mobile } = location.state || {};
  
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  // If no state data, redirect back to register
  React.useEffect(() => {
    if (!email || !name || !mobile) {
      alert('Please register first');
      navigate('/register');
    }
  }, [email, name, mobile, navigate]);

  const handleRegister = async () => {
    if (password.length < 6) {
      alert('Password must be at least 6 characters long.');
      return;
    }

    if (password !== password2) {
      alert('Both passwords do not match.');
      return false;
    }
    
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('email', email);
      formData.append('password', password);
      formData.append('name', name);
      formData.append('mobile', mobile);

      const response = await fetch("https://fx4money.com/Rest/web_otp_verify_api2", {
        method: "POST",
        body: formData,
        headers: {
          'Accept': 'application/json',
        },
      });

      const data = await response.json();
      console.log(data);
      
      if (data.status === 'success') {
        localStorage.setItem('userid', data.lid);
        localStorage.setItem('userEmail', email);
        localStorage.setItem('userName', name);
        alert('Account created successfully!');
        navigate('/upload-docs/'+data.lid);
      } else {
        alert(data.msg || 'Registration failed. Please try again.');
      }
    
    } catch (error) {
      console.error('Registration error:', error);
      alert("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <div 
      className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{ 
        backgroundColor: '#F8F9FA',
        padding: '20px'
      }}
    >
      {/* Loading Overlay */}
      {loading && (
        <div 
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}
        >
          <div className="bg-white p-4 rounded-4 text-center shadow-lg">
            <Spinner animation="border" variant="primary" style={{ width: 40, height: 40 }} />
            <div className="mt-3 text-secondary fw-semibold" style={{ fontSize: 13 }}>
              Creating your account...
            </div>
          </div>
        </div>
      )}

      {/* Main Content Container */}
      <div style={{ maxWidth: 500, width: '100%', alignSelf: 'center' }}>
        
        {/* Header */}
        <div className="text-center mb-4">
          <div className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10" style={{ width: 70, height: 70 }}>
            <i className="bi bi-shield-lock" style={{ fontSize: 32, color: '#0054bd' }}></i>
          </div>
          <h1 className="fw-bold mb-2" style={{ color: '#1A1A1A', fontSize: 'clamp(24px, 6vw, 28px)' }}>
            Set Account Password
          </h1>
          <p className="text-secondary mb-0" style={{ fontSize: 'clamp(13px, 4vw, 14px)' }}>
            Create a secure password for your account
          </p>
        </div>
        
        {/* Password Card */}
        <div 
          className="bg-white rounded-4 p-4 p-md-5 mb-4"
          style={{ 
            boxShadow: '0 4px 20px rgba(0,84,189,0.08)',
            border: '1px solid #E8E8E8'
          }}
        >
          {/* Email/User Info Display */}
          <div className="text-center mb-4 pb-2 border-bottom" style={{ borderBottomColor: '#E8E8E8' }}>
            <div className="d-flex align-items-center justify-content-center gap-3 flex-wrap">
              <div className="d-flex align-items-center">
                <i className="bi bi-envelope text-primary me-2" style={{ fontSize: 14 }}></i>
                <span className="text-secondary" style={{ fontSize: 13 }}>{email}</span>
              </div>
              <div className="d-flex align-items-center">
                <i className="bi bi-person text-primary me-2" style={{ fontSize: 14 }}></i>
                <span className="text-secondary" style={{ fontSize: 13 }}>{name}</span>
              </div>
              <div className="d-flex align-items-center">
                <i className="bi bi-phone text-primary me-2" style={{ fontSize: 14 }}></i>
                <span className="text-secondary" style={{ fontSize: 13 }}>{mobile}</span>
              </div>
            </div>
          </div>
          
          {/* Password Input */}
          <div className="mb-3">
            <label className="form-label fw-semibold small text-uppercase mb-2" style={{ color: '#0054bd', fontSize: 11, letterSpacing: 0.5 }}>
              Password
            </label>
            <div className="d-flex align-items-center bg-light rounded-3 p-3 border" style={{ backgroundColor: '#F8F9FA', borderColor: '#E8E8E8' }}>
              <i className="bi bi-lock me-3" style={{ fontSize: 18, color: '#0054bd' }}></i>
              <input
                type={passwordVisible ? "text" : "password"}
                className="form-control bg-transparent border-0 p-0"
                style={{ fontSize: 15, fontWeight: 500 }}
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                className="btn btn-link p-0 text-decoration-none"
                onClick={togglePasswordVisibility}
                style={{ color: '#0054bd' }}
              >
                <i className={`bi bi-${passwordVisible ? 'eye-slash' : 'eye'}`} style={{ fontSize: 18 }}></i>
              </button>
            </div>
          </div>
          
          {/* Confirm Password Input */}
          <div className="mb-4">
            <label className="form-label fw-semibold small text-uppercase mb-2" style={{ color: '#0054bd', fontSize: 11, letterSpacing: 0.5 }}>
              Confirm Password
            </label>
            <div className="d-flex align-items-center bg-light rounded-3 p-3 border" style={{ backgroundColor: '#F8F9FA', borderColor: '#E8E8E8' }}>
              <i className="bi bi-lock me-3" style={{ fontSize: 18, color: '#0054bd' }}></i>
              <input
                type={passwordVisible ? "text" : "password"}
                className="form-control bg-transparent border-0 p-0"
                style={{ fontSize: 15, fontWeight: 500 }}
                placeholder="Confirm password"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
              />
            </div>
          </div>
          
          {/* Password Requirements */}
          <div className="d-flex flex-wrap justify-content-center gap-3 mt-2 pt-2">
            <div className="d-flex align-items-center">
              <div className={`rounded-circle me-2 ${password?.length >= 6 ? 'bg-success' : 'bg-secondary'}`} style={{ width: 6, height: 6 }}></div>
              <span className={password?.length >= 6 ? 'text-success' : 'text-secondary'} style={{ fontSize: 12, fontWeight: 500 }}>
                Min. 6 characters
              </span>
            </div>
            
            {password.length > 0 && password2.length > 0 && (
              <div className="d-flex align-items-center">
                <div className={`rounded-circle me-2 ${password === password2 && password !== '' ? 'bg-success' : 'bg-secondary'}`} style={{ width: 6, height: 6 }}></div>
                <span className={password === password2 && password !== '' ? 'text-success' : 'text-secondary'} style={{ fontSize: 12, fontWeight: 500 }}>
                  Passwords match
                </span>
              </div>
            )}
          </div>
          
          {/* Password Strength Indicator */}
          {password.length > 0 && (
            <div className="mt-3">
              <div className="d-flex justify-content-between align-items-center mb-1">
                <span className="small text-secondary">Password strength</span>
                <span className="small fw-semibold" style={{
                  color: password.length < 6 ? '#EF4444' : 
                         password.length < 8 ? '#F59E0B' : '#10B981'
                }}>
                  {password.length < 6 ? 'Weak' : 
                   password.length < 8 ? 'Medium' : 'Strong'}
                </span>
              </div>
              <div className="progress" style={{ height: 4, backgroundColor: '#E5E7EB' }}>
                <div 
                  className="progress-bar" 
                  role="progressbar" 
                  style={{ 
                    width: `${Math.min((password.length / 12) * 100, 100)}%`,
                    backgroundColor: password.length < 6 ? '#EF4444' : 
                                   password.length < 8 ? '#F59E0B' : '#10B981'
                  }}
                />
              </div>
            </div>
          )}
        </div>
        
        {/* Submit Button */}
        <div className="px-3">
          <button
            className="btn w-100 py-3 fw-bold"
            style={{
              backgroundColor: '#0054bd',
              color: '#FFFFFF',
              fontSize: 'clamp(14px, 4vw, 16px)',
              borderRadius: 16,
              letterSpacing: 1,
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 14px rgba(0,84,189,0.25)'
            }}
            onClick={handleRegister}
            disabled={loading}
          >
            {loading ? (
              <div className="d-flex align-items-center justify-content-center gap-2">
                <Spinner animation="border" size="sm" style={{ color: '#fff' }} />
                <span>CREATING ACCOUNT...</span>
              </div>
            ) : (
              'CREATE ACCOUNT →'
            )}
          </button>
        </div>
        
        {/* Footer Note */}
        <div className="text-center mt-4 pt-2">
          <p className="text-secondary small" style={{ fontSize: 12, lineHeight: 1.5 }}>
            By continuing, you agree to our{' '}
            <a href="/terms" className="text-decoration-none" style={{ color: '#0054bd' }}>Terms of Service</a>
            {' '}and{' '}
            <a href="/privacy" className="text-decoration-none" style={{ color: '#0054bd' }}>Privacy Policy</a>
          </p>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
        
        body {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }
        
        .form-control:focus {
          box-shadow: none;
          outline: none;
        }
        
        .btn:focus {
          outline: none;
          box-shadow: none;
        }
        
        .progress {
          border-radius: 2px;
        }
        
        .progress-bar {
          transition: width 0.3s ease;
        }
        
        @media (max-width: 480px) {
          .p-md-5 {
            padding: 1.5rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Password;